export const stepsData: string[] = [
  "Basic Details",
  "Qualifications",
  "Work Details",
];
